var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hm-button",class:[("hm-button-" + _vm.type),{
    'is-plain': _vm.plain,
    'is-round': _vm.round,
    'is-circle': _vm.circle,
    'is-disabled': _vm.disabled
}],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('i',{class:("icon-fang-" + _vm.icon)}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }